export default {
  name: 'informations_private_message',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_options: {
    is_textarea: true
  }
}